import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactGA from 'react-ga';
import { siteMetadata } from '../../data/siteMetadata';
import { ReactGAEvents } from '../../utils/Constants';
import SocialIcon from '../social-icons';

export const Footer: React.FC = () => {
    return (
        <footer>
            <div className="flex flex-col items-center mt-16 pb-8">
                <div className="flex mb-4 space-x-8">
                    <SocialIcon kind="mail" href={`mailto:${siteMetadata.email}`} size={5} />
                    <SocialIcon kind="github" href={siteMetadata.github} size={5} />
                    <SocialIcon kind="linkedin" href={siteMetadata.linkedin} size={5} />
                    <SocialIcon kind="twitter" href={siteMetadata.twitter} size={5} />
                </div>
                <div className="flex space-x-2 text-xs font-mono text-neutral-600">
                    <div>{siteMetadata.author}</div>
                    <div>{' / '}</div>
                    <div>{`${new Date().getFullYear()}`}</div>
                    <div>{' / '}</div>
                    <NavLink
                        to="/"
                        onClick={() => {
                            ReactGA.event({
                                category: ReactGAEvents.InternalLink,
                                action  : 'Clicked Internal Link /',
                            });
                        }}
                        className="hover:text-red-500 transition-colors"
                    >{siteMetadata.title}
                    </NavLink>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
